import api, { TipoOptions } from './api';
import { OptionProps } from '@digital/ui';

export const getAllOrcamentario = () => api.get<any[]>('status/getAllTipoProjetoPrevisao');

export const getAllOrcamentarioOptions = () => {
    return getAllOrcamentario().then(Tipo =>
        (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
    );
}
